import React from 'react';
import './css/Footer.css';

import { Link } from 'react-router-dom'

class Footer extends React.Component {
  render() {
    return(
      <div>
      <footer className="footer-bar">
        <div>&copy; <Link to="/home">Sarathi</Link>, Mumbai</div>
        <div>Developed and maintained by Vishal Ludhrani, Yash Khavnekar and Sandeep Sabu</div>
      </footer>
      </div>
    );
  }
}

export default Footer;
